import { CommonModule } from '@angular/common';
import { Component, Inject, inject, computed, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { injectMutation } from '@ngneat/query';
import {
  MessagingResendData,
  MessagingResendPayload,
} from '@features/order-detail/models/order-messaging.model';
import { OrderMessagingService } from '@features/order-detail/services/order-messaging.service';
import { HorusLoadingComponent } from '@shared/components/domain/horus-loading/horus-loading.component';
import { HorusMessageGeneralComponent } from '@shared/components/domain/horus-message-general/horus-message-general.component';
import { MessageTypeLabelComponent } from '@shared/components/domain/message-type-label/message-type-label.component';
import { SendIconComponent } from '@shared/components/ui/icons/send-icon.component';
import { HorusBtnDirective } from '../../../../shared/directives/horus-btn.directive';

@Component({
  selector: 'app-od-messaging-resend-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    HorusLoadingComponent,
    HorusMessageGeneralComponent,
    MessageTypeLabelComponent,
    MatIcon,
    SendIconComponent,
    HorusBtnDirective,
  ],
  templateUrl: './od-messaging-resend-dialog.component.html',
  styleUrl: './od-messaging-resend-dialog.component.scss',
})
export class OdMessagingResendDialogComponent implements OnInit {
  dialogRef = inject(MatDialogRef<OdMessagingResendDialogComponent>);
  dialog = inject(MatDialog);
  private readonly orderMessagingService = inject(OrderMessagingService);
  private readonly mutation = injectMutation();

  readonly form = new FormGroup({
    email: new FormControl(this.data.to, [Validators.required]),
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: MessagingResendData) {}

  readonly resendMutation = this.mutation({
    mutationFn: (payload: MessagingResendPayload) =>
      this.orderMessagingService.resendMessage(payload),
    onError: (error: any) => {
      console.error('Error resending message:', error);
    },
  });

  // Note: Using result$ | async in template instead of computed signals
  // to avoid NG0602 error with toSignal() in reactive context

  ngOnInit(): void {}

  onResendMail() {
    const payload: MessagingResendPayload = {
      tenantId: this.data.tenantId,
      emailId: this.data.emailId,
      to: this.form.value.email!,
      origin: 'HORUS',
    };
    if (this.form.valid) {
      this.resendMutation.mutate(payload);
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  action(){
    this.dialogRef.close();
  }
}
